/**
 * Les deux lectures de départ de la fiche « Ma lecture ». Mêmes valeurs que le backend
 * (`StudentProfile::READING_STANDARD` / `READING_ADAPTED`) : le serveur résout la lecture
 * d'office, l'app applique les préréglages quand l'élève bascule l'interrupteur.
 */
export const READING_STANDARD = {
    adapted: false,
    font: "standard",
    size: 16,
}

export const READING_ADAPTED = {
    adapted: true,
    font: "lexend",
    size: 21,
}

/** Les trois tailles de la fiche, du standard du lot 1 au grand texte de la lecture adaptée. */
export const READING_SIZES = [
    { value: 16, glyph: 13, label: "Texte normal" },
    { value: 18, glyph: 17, label: "Texte grand" },
    { value: 21, glyph: 21, label: "Texte très grand" },
]

export const READING_FONTS = [
    { value: "standard", label: "Standard" },
    { value: "lexend", label: "Lexend" },
]

/** Ce que l'élève choisit, sans ce que le serveur en déduit (`applied_by_default`, le message). */
export function readingChoice({ adapted, font, size }) {
    return { adapted, font, size }
}

export function sameReading(a, b) {
    return a.adapted === b.adapted && a.font === b.font && a.size === b.size
}

/** Un réglage n'est plus standard : l'icône « Aa » le montre, sans pour autant crier. */
export function isCustomReading(reading) {
    return !sameReading(reading, READING_STANDARD)
}
